import Vue from 'vue'
import Router from 'vue-router'
import RouterCommon from './module/common' // 引入通用模块
import RouterFive from './module/RouterFive' // 引入通用模块

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

NProgress.configure({
    easing: 'ease', // 动画方式
    speed: 500, // 递增进度条的速度
    showSpinner: false, // 是否显示加载ico
    trickleSpeed: 200, // 自动递增间隔
    minimum: 0.3 // 初始化时的最小百分比
})

Vue.use(Router)

const router = new Router({
    routes: [
        ...RouterCommon,
        ...RouterFive
    ],
    /**
     * @param {*} to
     * @param {*} from
     * @param {*} savedPosition
     * *第三个参数 savedPosition 当且仅当 popstate 导航 (通过浏览器的 前进/后退 按钮触发) 时才可用
     */
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            // 与keepAlive相结合，但是试了试好像没有什么作用？？？？
            if (from.meta.keepAlive) {
                from.meta.savedPosition = document.body.scrollTop
            }
            return {
                x: 0,
                y: to.meta.savedPosition || 0
            }
        }
    }
})
const cancelLastReq = (next) => {
    let axiosPromiseArr = window.__axiosPromiseArr || []
    if (!!axiosPromiseArr && axiosPromiseArr.length) {
        let len = axiosPromiseArr.length
        while (len--) {
            axiosPromiseArr[len].cancel('cancel')
            axiosPromiseArr.splice(len, 1)
        }
    }
    next()
}
// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
    return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
    NProgress.start()
    cancelLastReq(next)
})

router.afterEach((to, from) => {
    // 在即将进入新的页面组件前，关闭掉进度条
    NProgress.done()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js